





























































import Vue from "vue";
import DepartmentGridItem from "./DepartmentGridItem.vue";
import Processing from "@/components/table/Processing.vue";
import { state } from "./data/state";
import {
  FamiliarityItem,
  FamiliarityLevel,
  FamiliarityStatus,
} from "./data/models";
import { computed, ref } from "@vue/composition-api";
import { UseLocalSearch } from "@/common/composition/use-search";
export default Vue.extend({
  components: { DepartmentGridItem, Processing },
  setup() {
    const {
      current_display_list: items,
      manage_trust,
      load_more_items,
      is_loading_all,
    } = state;
    const [query, is_searching] = UseLocalSearch(0);
    const gridRef = ref<HTMLElement | null>(null);
    const is_loading_more = ref(false);

    const onScroll = async () => {
      const el = gridRef.value;
      if (!el || is_loading_more.value || is_loading_all.value) return;
      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 200;
      if (nearBottom) {
        is_loading_more.value = true;
        await load_more_items();
        is_loading_more.value = false;
      }
    };

    const manage = async (item: {
      id: string;
      name: string;
      level: FamiliarityLevel;
      status: FamiliarityStatus;
    }) => {
      const f_item: FamiliarityItem = {
        entityId: item.id,
        internalEntityId: item.id,
        labelId: "",
        email: item.name,
        addedAt: "",
        score: 0,
        firstEventAt: "",
        lastEventAt: "",
        exposer_balance: {
          from: 0,
          to: 0,
        },
        eventCount: 0,
        level: item.level,
        status: item.status,
        affinity: 0,
      };
      await manage_trust(f_item);
    };
    "".toLowerCase;
    const display_list = computed(() => {
      if (is_searching.value) {
        const regex = new RegExp(query.value, "i");
        return items.value.filter(
          // @ts-ignore
          (f: { name: string }) => f.name.search(regex) > -1
        );
      } else {
        return items.value;
      }
    });

    return {
      display_list,
      manage,
      query,
      gridRef,
      is_loading_more,
      onScroll,
    };
  },
});
